import { useMediaQuery as useMuiMediaQuery, useTheme } from "@mui/material";

/** Shared responsive breakpoint hook for feature composition. */
export const useBreakpointDown = (breakpoint: "sm" | "md" | "lg") => {
  const theme = useTheme();
  return useMuiMediaQuery(theme.breakpoints.down(breakpoint));
};
